var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddSocialAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 16.0789C10.9375 12.4455 13.8756 9.5 17.5 9.5C21.1244 9.5 24.0625 12.4455 24.0625 16.0789C24.0625 19.7124 21.1244 22.6579 17.5 22.6579C13.8756 22.6579 10.9375 19.7124 10.9375 16.0789ZM17.5 20.0263C19.6746 20.0263 21.4375 18.259 21.4375 16.0789C21.4375 13.8989 19.6746 12.1316 17.5 12.1316C15.3254 12.1316 13.5625 13.8989 13.5625 16.0789C13.5625 18.259 15.3254 20.0263 17.5 20.0263Z",
    fill: "#2E3A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0754 27.0568C8.10625 29.0308 7 31.7082 7 34.5H9.625C9.625 32.4062 10.4547 30.3981 11.9315 28.9176C13.4084 27.437 15.4114 26.6053 17.5 26.6053C19.5886 26.6053 21.5916 27.437 23.0685 28.9176C24.5453 30.3981 25.375 32.4062 25.375 34.5H28C28 31.7082 26.8938 29.0308 24.9246 27.0568C22.9555 25.0827 20.2848 23.9737 17.5 23.9737C14.7152 23.9737 12.0445 25.0827 10.0754 27.0568Z",
    fill: "#2E3A59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 9.1H31.4V5.5H29.6V9.1H26V10.9H29.6V14.5H31.4V10.9H35V9.1Z",
    fill: "#2E3A59"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSocialAccount);
export default __webpack_public_path__ + "static/media/add-social-account.89b5e8e4.svg";
export { ForwardRef as ReactComponent };